import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import EvaluationPanel from "./EvaluationPanel";
import ActivityPanel from "./ActivityPanel";

const RightPanel = ({
  analysis,
  company_config,
  is_sider,
  has_comments_feature,
  comments_props,
  on_close,
}) => {
  const { t } = useTranslation();
  const [active_tab, set_active_tab] = useState("evaluation");
  const comments_count = comments_props?.comments?.length || 0;

  const tab_button_class = (key) =>
    `flex-1 px-3 py-2.5 text-xs font-medium text-center transition-colors ${
      active_tab === key
        ? "text-gray-900 border-b-2 border-primary"
        : "text-gray-500 hover:text-gray-700"
    }`;

  return (
    <div className="w-[320px] flex flex-col border-l border-gray-200 bg-white">
      <div className="flex items-center border-b border-gray-200 bg-white">
        <button
          type="button"
          onClick={() => set_active_tab("evaluation")}
          className={tab_button_class("evaluation")}
        >
          {t("Évaluation")}
        </button>
        {has_comments_feature && (
          <button
            type="button"
            onClick={() => set_active_tab("activity")}
            className={tab_button_class("activity")}
          >
            {t("Activité")}
            {comments_count > 0 && <span className="ml-1 text-gray-400">· {comments_count}</span>}
          </button>
        )}
        <button
          type="button"
          onClick={on_close}
          className="px-3 py-2.5 text-gray-400 hover:text-gray-600"
          aria-label="Close"
        >
          ✕
        </button>
      </div>
      <div className="flex-1 overflow-y-auto p-4">
        {active_tab === "evaluation" && (
          <EvaluationPanel
            analysis={analysis}
            company_config={company_config}
            is_sider={is_sider}
          />
        )}
        {active_tab === "activity" && has_comments_feature && <ActivityPanel {...comments_props} />}
      </div>
    </div>
  );
};

export default RightPanel;
